import React from 'react'
import { TeamAssistTracker } from 'Components/GameTicker/TeamAssistTracker/TeamAssistTracker'

const AssistTracker: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <TeamAssistTracker teamId={'RED'} />
    </>
  )
}

export default AssistTracker
